<template>
  <div class="not-found">
    <h1>Erro: 404</h1>
    <p>PÁGINA NÃO ENCONTRADA! :(</p>
  </div>
</template>

<script>
export default {
  components: {
  }
};
</script>

<style scoped>
.not-found {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
</style>